module.exports = __webpack_public_path__ + "img/WFD.7e370f76.png";